import { render, staticRenderFns } from "./Lessonplans.vue?vue&type=template&id=fd9063fe&"
import script from "./Lessonplans.vue?vue&type=script&lang=js&"
export * from "./Lessonplans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports